import { useRef } from 'react'
import type { SearchContentProps } from '../searchContent/searchContent'
import { SearchContent } from '../searchContent/searchContent'
import styles from './desktopSearch.module.css'

export function DesktopSearch(props: SearchContentProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div className={styles.container}>
      <SearchContent {...props} ref={inputRef} />
    </div>
  )
}
